import { useQuery } from '@tanstack/react-query';
import { ApiHandler } from '../handlers';
import { RecurringDonation } from '../models';
import { logError } from '../../utils/logError';

export const RECURRING_DONATIONS_QUERY_KEY = 'currentRecurringDonations';

export const recurringDonationsQueryFn = async (): Promise<
    RecurringDonation[]
> => {
    const response = await ApiHandler.instance.donor.getAllRecurringDonations();
    if (!response.success) {
        if (response.error.status === 500 && !response.error.isAxiosError) {
            logError('API Request Error: 500', response.error);
        }
        throw new Error('Failed to fetch recurring donations');
    }
    return response.data.response.payload;
};

const useRecurringDonationsQuery = (enabled: boolean) => {
    return useQuery({
        queryKey: [RECURRING_DONATIONS_QUERY_KEY],
        queryFn: recurringDonationsQueryFn,
        enabled,
        staleTime: 1000 * 60 * 5,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
    });
};

export const useRecurringDonations = (enabled = false) => {
    const { data, isFetched, isFetching, isLoading, isError, error, refetch } =
        useRecurringDonationsQuery(enabled);

    return {
        recurringDonations: data,
        isFetching,
        isLoading,
        hasNeverFetched: !isFetched && !isFetching,
        isError,
        error,
        refetch,
    };
};
